import { useCheckoutAccordion } from '../../CheckoutAccordion/CheckoutAccordionProvider';
import { useCheckoutInfoIsValid } from './useCheckoutInfoIsValid';
import { useMaybeUpdateUser } from './useMaybeUpdateUser';

export const useCheckoutInfo = () => {
  const maybeUpdateUser = useMaybeUpdateUser();
  const { setExpanded } = useCheckoutAccordion();

  const handleContinue = () => {
    maybeUpdateUser();
    setExpanded('payments');
  };

  const { docsValid, formValid } = useCheckoutInfoIsValid();

  return {
    docsValid,
    formValid,
    handleContinue,
    isValid: formValid && docsValid,
  };
};
